import { Component, OnInit, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { log } from 'util';


@Component({
    selector: 'sticky-header',
    templateUrl: './sticky-header.component.html',
    styleUrls: ['./sticky-header.component.css']

})
export class StickyHeaderComponent implements OnInit {

    @Output() sectionPosition = new EventEmitter();
    @Input() title: any;

    constructor(private element: ElementRef) { }

    ngOnInit() {
        this.sectionPosition.emit({ name: this.title, position: this.element.nativeElement.offsetTop });
    }


    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.sectionPosition.emit({ name: this.title, position: this.element.nativeElement.offsetTop });
    }

}
